module.exports = __webpack_public_path__ + "fonts/Charlie_Text-Semibold.0bb7b52ebc5c34a86656.woff";